import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    // uploadError.ts
    whatVideo: 'видео',
    whatFile: 'файл',
    tooLargeMb: (mb: string) =>
      `Файл слишком большой: можно загрузить до ${mb} МБ. Сожмите картинку или выберите другую.`,
    tooLarge: 'Файл слишком большой. Сожмите его или выберите другой.',
    badFormat: 'Этот формат не подходит. Загрузите PNG, JPG или WebP.',
    noAccess: 'Нет доступа к загрузке. Войдите в аккаунт заново и попробуйте ещё раз.',
    server: (what: string) => `Сервер не смог принять ${what}. Попробуйте ещё раз через минуту.`,
    offline: 'Нет соединения с интернетом. Проверьте сеть и попробуйте ещё раз.',
    failed: (what: string) => `Не удалось загрузить ${what}. Попробуйте ещё раз.`,
  },
  en: {
    whatVideo: 'the video',
    whatFile: 'the file',
    tooLargeMb: (mb: string) =>
      `The file is too large — the limit is ${mb} MB. Compress the image or choose another one.`,
    tooLarge: 'The file is too large. Compress it or choose another one.',
    badFormat: 'This format isn’t supported. Upload a PNG, JPG or WebP.',
    noAccess: 'You don’t have permission to upload. Sign in again and retry.',
    server: (what: string) => `The server couldn’t accept ${what}. Try again in a minute.`,
    offline: 'No internet connection. Check your network and try again.',
    failed: (what: string) => `Couldn’t upload ${what}. Try again.`,
  },
})
